export function getReaderPriorityPresentation(priority) {
  if (priority === 'DEEP_DIVE') return { mode: 'deep-dive', label: 'Approfondimento' };
  if (priority === 'SHOULD_KNOW') return { mode: 'cue', label: 'Da ricordare' };
  return { mode: 'main', label: null };
}
